"use client";
import { formatCurrencyPipeText } from "@/core/pipes/format-currency.pipe";
import {
  AccumulationChartComponent,
  AccumulationDataLabel,
  AccumulationLegend,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  AccumulationTooltip,
  DataPoint,
  Inject,
  PieSeries,
} from "@syncfusion/ej2-react-charts";
import { Empty, Spin } from "antd";
import { ReactNode } from "react";

interface StatsPieChartProps {
  data?: { x: string; y: number }[];
  palettes: string[];
  template?: (args: any) => ReactNode;
  height: string;
  unit?: string;
}
export const StatsPieChart: React.FC<StatsPieChartProps> = ({
  data,
  palettes,
  template,
  height,
  unit
}) => {
  if (!data)
    return (
      <div
        style={{ height: `${height}px` }}
        className="flex flex-col items-center justify-center"
      >
        <Spin></Spin>
      </div>
    );
  if (
    data.length === 0 ||
    data.reduce((a, c) => ({ x: "", y: a.y + c.y })).y === 0
  )
    return (
      <div
        style={{ height: `${height}px` }}
        className="flex flex-col items-center justify-center"
      >
        <Empty></Empty>
      </div>
    );
  return (
    <AccumulationChartComponent
      legendSettings={{ visible: true, position: "Bottom" }}
      tooltip={{ 
        enable: true,
        format: '${point.x} : ${point.y}'+unit
      }}
      height={height}
      enableSmartLabels
    >
      <Inject
        services={[
          PieSeries,
          AccumulationLegend,
          AccumulationDataLabel,
          AccumulationTooltip,
        ]}
      />
      <AccumulationSeriesCollectionDirective>
        <AccumulationSeriesDirective
          dataSource={data}
          xName="x"
          yName="y"
          palettes={palettes}
          dataLabel={{
            visible: true,
            position: "Inside",
            name: "text",
            template: template,
          }}
        />
      </AccumulationSeriesCollectionDirective>
    </AccumulationChartComponent>
  );
};
